module.exports = "/_next/static/images/Hero-lg@2x-7a99f86afbcd8e9ae10ad2a52b5b42a5.webp";